import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const BudgetDepartmentCell = ({
  hasMultiple,
  budget,
}: ColumnTypeData['BUDGET_DEPARTMENT']) => {
  const intl = useProcurifyIntl()

  if (hasMultiple) return <>{intl.formatMessage(messages.multipleLabel)}</>

  return (
    <>
      {budget
        ? `${budget.department.branch.name} - ${budget.department.name}`
        : ''}
    </>
  )
}
